// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    // lemsarApiEndpoint: 'https://kelembagaan-api.kemnaker.go.id/v1/',
    lemsarApiEndpoint: 'https://api-sandbox.kemnaker.go.id/lemlat/v1/',
    nacoClientId: '7b886bd3-a81e-431f-960b-d82110938c69',
    pelatihanUrl: 'https://pelatihan.kemnaker.go.id/',
    accountUrl: 'https://account.kemnaker.go.id/',
    siproUrl: 'https://proglat-dev.kemnaker.go.id/',
    skillHubUrl: 'https://pelatihan-dev.kemnaker.go.id/',
    acemUrl: 'https://sandbox-accreditation-console.kemnaker.go.id/',
};



// WEBPACK FOOTER //
// ./environments/environment.ts